var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropofft1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.714 4h2.572A1.72 1.72 0 0 1 10 5.714v2.572A1.72 1.72 0 0 1 8.286 10H5.714A1.72 1.72 0 0 1 4 8.286V5.714A1.72 1.72 0 0 1 5.714 4z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01 8.428A1.433 1.433 0 0 1 5.583 7c0-.786.629-1.429 1.429-1.429h.014c.786 0 1.428.643 1.428 1.429s-.642 1.428-1.442 1.428z",
    fill: "#979797"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 7,
    height: 7,
    rx: 1.167,
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropofft1);
export default __webpack_public_path__ + "static/media/dropofft1.d5a2f935e52f8b7e4e79021a31b5ee7b.svg";
export { ForwardRef as ReactComponent };